import {FORCE_ALL_FLAGS_SENTINEL} from '@sollapay/types';
import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {featureFlagsApi} from '../api';

import type {FeatureFlagKey} from '../constants/feature-flags.constants';
import type {ApiResponse, FeatureFlagsDTO} from '@sollapay/types';

export const featureFlagsKeys = {
  all: ['feature-flags'] as const
};

// Module-level so React Query can memoize on identity — an inline `select` gets a new reference every render.
const selectFeatureFlags = (response: ApiResponse<FeatureFlagsDTO>) => response.data;

export function useFeatureFlagsQuery() {
  const client = useApiClient();

  return useQuery({
    queryKey: featureFlagsKeys.all,
    queryFn: () => featureFlagsApi.fetchFeatureFlags(client),
    select: selectFeatureFlags,
    staleTime: 60_000,
    refetchInterval: 60_000
  });
}

/** Fails closed: returns `false` while loading, on error, or for an unknown key — unless the server is forcing every flag on (e.g. local dev with no AppConfig connection). */
export function useFeatureFlag(key: FeatureFlagKey | (string & {})): boolean {
  const {data} = useFeatureFlagsQuery();
  if (data?.[FORCE_ALL_FLAGS_SENTINEL]) return true;
  return data?.[key] ?? false;
}
